import React from 'react';
import StyleSheet from './StyleSheet';
import * as MaterialIcons from 'react-icons/md';

const Icon3 = ({ name, size = 24, color = '#000', type = 'MaterialIcons', style, onPress, ...props }) => {
  const flatStyle = StyleSheet.flatten ? StyleSheet.flatten(style) : style;
  
  // Get the icon component from react-icons
  const IconComponent = MaterialIcons[name];
  
  if (!IconComponent) {
    console.warn(`Icon "${name}" not found in Material Icons`);
    return null;
  }
  
  return (
    <span
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        cursor: onPress ? 'pointer' : 'default',
        userSelect: 'none',
        ...flatStyle
      }}
      onClick={onPress}
      {...props}
    >
      <IconComponent size={size} color={color} />
    </span>
  );
};

export default Icon3;
